export default function Text ({ size=1, className, children, colorOverride=false }) {
    return (
        <p className={`${!colorOverride ? 'text-gray-700' : ''} ${size == 1 ? 'text-xl' : size==2 ? 'text-lg' : 'text-base'} ${className}`}>
            { children }
        </p>
    )
}